
import { getCourseLeaderboard, PaginatedData } from "@/api";
import { GamificationUser } from "@/models";
import { defineComponent } from "@vue/runtime-core";
import Btn from "@/components/ui/Btn.vue";
import Avatar from "@/components/ui/Avatar.vue";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default defineComponent({
	name: "PublicGamificationLeaderboard",
	components: { Btn, Avatar },
	props: {
		courseId: {
			type: String,
			required: true as const,
		},
	},
	async created() {
		this.firstLoading = true;
		try {
			await this.mainStore.getCourseGamificationContext({ courseId: this.courseId });
			if (this.mainStore.gamificationContext) {
				this.paginatedUsers = await getCourseLeaderboard(
					this.mainStore.gamificationContext.id,
					this.pageNumber,
				);
				this.pageSize = Math.max(1, this.paginatedUsers.data.length);
			}
		} finally {
			this.firstLoading = false;
		}
	},
	data() {
		return {
			firstLoading: true,
			loading: false,
			paginatedUsers: null as PaginatedData<GamificationUser> | null,
			pageNumber: 1,
			pageSize: 1,
		};
	},
	computed: {
		...mapStores(useMainStore),
		lastPageNumber(): number {
			return Math.ceil((this.paginatedUsers?.count ?? 0) / this.pageSize);
		},
		pageNumbers(): number[] {
			return [...Array(this.lastPageNumber).keys()].map(p => p + 1);
		},
	},
	methods: {
		getUserPosition(userId: string): number {
			return (
				this.pageSize * (this.pageNumber - 1) +
				(this.paginatedUsers?.data ?? []).findIndex(u => u.id == userId) +
				1
			);
		},
		async changePage(page: number) {
			this.pageNumber = page;
			this.loading = true;
			try {
				await this.mainStore.getCourseGamificationContext({ courseId: this.courseId });
				this.paginatedUsers = await getCourseLeaderboard(
					this.mainStore.gamificationContext?.id ?? "",
					this.pageNumber,
				);
			} finally {
				this.loading = false;
			}
		},
	},
});
